<template>
  <!-- 补充资料 -->
  <common-modal :is-show-close="isShowClose" @close="close">
    <div class="agree-wrap">
      <h1>用心淘下单协议</h1>
      <div class="agree-text">
        <p>1、处理期间，请拉黑或不与消费者联系、不对评价回复或解释（已回复的不影响处理）；</p>
        <p>2、处理周期为五天，期限内撤单须扣除该订单付款金额50%违约金，五天期限后可正常申请退款 ；</p>
        <p>3、五天处理期限内，不自行或交由他人处理，期限内解决的订单，都代表任务完成，应当收取费用 。</p> 
      </div>
    </div>
  </common-modal>
</template>

<script>
import commonModal from '@/components/commonModal.vue';
export default {

  components: {
    commonModal,
  },
  data() {
    return {
      isShowClose: true
    }
  },

  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
    //补充资料
    .agree-wrap{
        h1{
            border-bottom: 0.026667rem solid #E9E9E9;
            padding: 15px;
            text-align:center;
            @include font-style;
            font-size: 20px;
            color: #000000;
        }
        .agree-text{
            box-sizing: border-box;
            padding: 40px;
            background: #FFFFFF;
            line-height:30px;
            letter-spacing: 2px;
            p{
                margin-bottom: 20px;
            }
            p:last-child{
                margin-bottom: 0;
            }
        }
    }
</style>
